export const CREATE_MEDIA = {
  route: "/mediaRequest/create",
  pageHeader: "Selected Assets",
  summaryHeader: "Selected Assets Summary",
  regionLabel: "Select Transfer Region",
  backButtonLabel: "Return to Media Request",
  mediaComingSoonLabel: "Media Coming Soon",
  videoLabel: "Video",
  audioLabel: "Audio",
  subtitlesLabel: "Subtitles",
  dubCardsLabel: "Dub Cards",
  proxyLabel: "Proxy",
  pathLabel: "Path: ",
  selectAllVideoLabel: "Select all video files",
  selectAllAudioLabel: "Select all audio files",
  selectAllSubtitlesLabel: "Select all subtitle files",
  selectAllDubCardsLabel: "Select all dub cards",
  selectAllProxyLabel: "Select all proxy files",
  noProxyAvailable: "No proxy available for the selected asset",
  jobType: "MEDIA_REQUEST",
  forwardButtonLabel: "Go to Cart"
};

export const SUMMARY_TABLE_HEADER = [
  "Asset Title",
  "Alternate Id",
  "Filename",
  "File Type",
  "Transfer Region",
  "",
];

export const SUMMARY_TABLE_VALUE_KEYS = [
  "title",
  "id",
  "renamedFilename",
  "fileType",
  "transfer",
];

export const PAGE_ERROR = {
  title: "Network Error",
  message: "Error Occured while fetching the selected assets information.",
};

export const AUDIO_CONTENT_KIND_MAPPING = {
  "urn:warnermedia:audio:content:smpte-st377-41-2021:primary": "Primary",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:secondary-audio-program":
    "Secondary Audio Program",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:hearing-impaired":
    "Hearing Impaired",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:music-and-effects":
    "Music And Effects",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:descriptive-video":
    "Descriptive",
  "urn:warnermedia:audio:content:descriptive-video-service-voice-over":
    "Descriptive Video Service Voice Over",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:live-commentary":
    "Live Commentary",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:recorded-commentary":
    "Recorded Commentary",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:dialog": "Dialog",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:music": "Music",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:effects": "Effects",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:filled-effects":
    "Filled Effects",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:program-narration":
    "Program Narration",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:optional-narration":
    "Optional Narration",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:optional-music-and-effects":
    "Optional Music And Effects",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:voice-over": "Voice Over",
  "urn:warnermedia:audio:content:smpte-st377-41-2021:visually-impaired":
    "Visually Impaired",
  "urn:warnermedia:audio:content:silence": "Silence",
  "urn:warnermedia:audio:content:dialog-effects": "Dialog Effects",
  "urn:warnermedia:audio:content:music-effects-no-vocals":
    "Music Effects No Vocals",
  "urn:warnermedia:audio:content:vocals": "Vocals",
  "urn:warnermedia:audio:content:dialog-music": "Dialog Music",
  "urn:warnermedia:audio:content:dialog-split": "Dialog Split",
  "urn:warnermedia:audio:content:dialog-music-effects": "Dialog Music Effects",
  "urn:wbd:audio:content:music-and-effects-with-sot":
    "Music And Effects With Sot",
  "urn:wbd:audio:content:sot-and-broll": "Sot And Broll",
  "urn:wbd:audio:content:dialog-effects-with-sot-bg":
    "Dialog Effects With Sot BG",
  "urn:wbd:audio:content:scratch-track": "Scratch Track",
  "urn:wbd:audio:content:laugh-track": "Laugh Track",
  "urn:wbd:audio:dialog-and-narration": "Dialog And Narration",
  "urn:wbd:audio:content:mix-minus-narration": "Mix Minus Narration",
  "urn:wbd:audio:content:unknown": "Unknown",
};

export const TEXT_USAGE_TYPE = {
  "urn:warnermedia:timed-text:usage-type:sdh": "SDH",
  "urn:warnermedia:timed-text:usage-type:full": "Full",
  "urn:warnermedia:timed-text:usage-type:forced": "Forced",
  "urn:warnermedia:timed-text:usage-type:captions": "Captions",
  "urn:wbd:timed-text:usage-type:compliance": "Compliance",
  "urn:wbd:timed-text:usage-type:descriptive-video": "Descriptive Video",
};

export const NAMESPACE_TO_ID_TYPE_MAPPING = {
  // GMSC namespaces
  "urn:warnermedia:titleid.titles.turner.com": "titleid",
  "urn:warnermedia:cid.turner.com": "cid",
  // HBO namespaces
  "urn:warnermedia:pavi.prime.hbo.com": "pavi",
  "urn:warnermedia:pafi.prime.hbo.com": "pafi",
  "urn:warnermedia:focusid.p2.hbo.com": "focusid",
  "urn:adid": "adid",
  "urn:isci": "isci",
  "urn:warnermedia:manifestation.warnermedia.com": "manifestationid",
  "urn:warnermedia:complianceid.meta.turner-int.com": "complianceid",
  "urn:warnermedia:houseid.ibms.hbo-lag.com": "houseid",
  "urn:warnermedia:mediaid.aleph.turner-lat.com": "mediaid",
  "urn:warnermedia:regionalclipid.foretv.hbo-nordic.com": "regionalclipid",
  "urn:warnermedia:contentid.ibeu.hbo-ce.com": "contentid",
  "urn:eidr": "eidr",
  // Discovery namespaces
  "urn:wbd:isci": "wbdisci",
  "urn:wbd:identifier:gabriel:house-number": "gabriel",
  "urn:wbd:identifier:ibms:ibms-media-id": "ibms",
  "urn:wbd:identifier:program-inventory:id": "pid",
  "urn:wbd:identifier:gcr:object-id": "gcr",
  "urn:wbd:identifier:program-inventory:cut-id": "cutid",
  "urn:wbd:identifier:program-inventory:paid": "paid",
  "urn:wbd:identifier:cat:isci": "catisci",
  //
  "dmicid": "dmicid",
  "dmititleid": "dmititleid",
  //Cantemo Namespaces
  "cantemofocusid": "cantemofocusid",
  //Bim Namespaces
  "bimcid": "bimcid",
  //Cut Namespaces
  "cutcid": "cutcid"
};

export const SOUND_FIELD_GROUP_TYPE = {
  "urn:warnermedia:audio:soundfield-group:smpte-st2067-201:iab": "Dolby ATMOS (IAB)",
  "urn:warnermedia:audio:soundfield-group:smpte-st428-12:5.1": "Surround 5.1",
  "urn:warnermedia:audio:soundfield-group:smpte-st2067-8:standard-stereo": "Standard Stereo",
  "urn:warnermedia:audio:soundfield-group:smpte-st2067-8:dual-mono": "Dual Mono",
  "urn:warnermedia:audio:soundfield-group:smpte-st2067-8:lt-rt": "Lt Rt",
  "urn:warnermedia:audio:soundfield-group:smpte-st428-12:1.0-monaural": "Monaural 1.0",
  "urn:warnermedia:audio:soundfield-group:smpte-st377-42:adss": "ADSS",
  'urn:warnermedia:audio:soundfield-group:smpte-st377-42:9.1.6': "Surround 9.1.6",
};

export const VIDEO_CODEC = {
  "urn:warnermedia:video:codec:prores422-hq": "PRORES422 HQ",
  "urn:warnermedia:video:codec:prores422": "PRORES422",
  "urn:warnermedia:video:codec:prores422-lt": "PRORES422 Lt",
  "urn:warnermedia:video:codec:prores422-proxy": "PRORES422 Proxy",
  "urn:warnermedia:video:codec:prores4444": "PRORES4444",
  "urn:warnermedia:video:codec:prores4444-xq": "PRORES4444 XQ",
  "urn:warnermedia:video:codec:avc": "AVC",
  "urn:warnermedia:video:codec:avc-intra": "AVC Intra",
  "urn:warnermedia:video:codec:jpeg2000": "JPEG 2000",
  "urn:warnermedia:video:codec:mpeg-2-video": "MPEG 2 Video",
  "urn:warnermedia:video:codec:mpeg-video": "MPEG Video",
  "urn:warnermedia:video:codec:dnxhd": "DNXHD",
  "urn:wbd:video:codec:dnxhd-lb": "DNXHD LB",
  "urn:wbd:video:codec:dnxhd-tr": "DNXHD TR",
  "urn:wbd:video:codec:dnxhd-sq": "DNXHD SQ",
  "urn:wbd:video:codec:dnxhd-hq": "DNXHD HQ",
  "urn:wbd:video:codec:dnxhd-hqx": "DNXHD HQX",
  "urn:wbd:video:codec:dnxhd-444": "DNXHD 444",
  "urn:wbd:video:codec:dnxhr-lb": "DNXHR LB",
  "urn:wbd:video:codec:dnxhr-sq": "DNXHR SQ",
  "urn:wbd:video:codec:dnxhr-hq": "DNXHR HQ",
  "urn:wbd:video:codec:dnxhr-hqx": "DNXHR HQX",
  "urn:wbd:video:codec:dnxhr-444": "DNXHR 444",
  "urn:wbd:video:codec:xavc-i": "XAVC I",
  "urn:wbd:video:codec:h264": "H264",
  "urn:wbd:video:codec:h265": "H265",
};

export const AUDIO_CODEC = {
  "urn:warnermedia:audio:codec:pcm": "PCM",
  "urn:warnermedia:audio:codec:aac": "AAC",
  "urn:warnermedia:audio:codec:dolbye": "DOLBYE",
  "urn:wbd:audio:codec:dolby-eac3": "DOLBY EAC3",
  "urn:wbd:audio:codec:dolby-ac3": "DOLBY AC3",
};

export const SUPPLEMENTARY_ASSET_TYPE = {
  "urn:warnermedia:manifestation:supplementary-asset-type:image": "Image",
  "urn:warnermedia:manifestation:supplementary-asset-type:report": "Report",
  "urn:warnermedia:manifestation:supplementary-asset-type:metadata": "Metadata",
};

export const IMAGE_TYPE = {
  "urn:warnermedia:image:type:dubbing-credit": "Dubbing Credit",
  "urn:warnermedia:image:type:logo": "Logo",
};

export const IMAGE_ENCODING = {
  "urn:warnermedia:image:encoding:png": "PNG",
  "urn:warnermedia:image:encoding:jpeg": "JPEG",
};

export const DEFAULT_PATH = "/{{environment}}/{{sAMAccountName}}";

export const REGION_PATHS = {
  "WBDShare": DEFAULT_PATH,
  "CS-DMG Promos": `/CSDMGPromos${DEFAULT_PATH}`,
  "Studios": DEFAULT_PATH,
  "Metal": DEFAULT_PATH,
  "TWD MOST": `/TWDMost${DEFAULT_PATH}`,
  "Content Customization": "/media/{{environment}}/{{requestName}}",
  "WMS Intl CS": `/WMSIntlCS${DEFAULT_PATH}`,
  "DETE": "/CRS-Cantemo",
  "BBFC Max UK": "/",
  "DP VAULT": {
    prod: "/Stager-PROD/Morph",
    nonProd: "/Stager-STG/Morph"
  },
  "DL_MMT": "/Marketing Ops DL_MMT",
  "Vobile CTN Ep. Masters": `/VobileCTNMobile${DEFAULT_PATH}`,
  "GSSNY": "/GSSNY_S3 Delivery/{{requestName}}",
  "GCSSNY-MX_Content App": "/{{requestName}}",
};

export const DELIVERY_REGION_MAP = {
  "studios": "Studios",
  "metal": "Metal",
  "content-customization": "Content Customization",
  "dete": "DETE",
  "gssny": "GSSNY",
  "bbfc-max-uk": "BBFC Max UK",
  "dp-vault": "DP VAULT",
  "hbo-aoc": "DL_MMT",
  "twd-most": "TWD MOST",
  "wms-intl-cs-group": "WMS Intl CS",
  "vobile-ctn-ep-masters": "Vobile CTN Ep. Masters"
};

export const AOC_DELIVERY_REGION_MAP = {
  "wbdshare-aoc": {
    "CS-DMG Promos": "CS-DMG Promos",
    "TWD MOST": "TWD MOST",
    "WMS Intl CS": "WMS Intl CS",
    "Vobile CTN Mobile": "Vobile CTN Ep. Masters",
    "WBDShare": "WBDShare",
    "GCSSNY-MX_Content App": "GCSSNY-MX_Content App",
  },
  "morph-to-wbd-share-aoc-bucket": {
    "WBDShare": "WBDShare",
    "CS-DMG Promos": "CS-DMG Promos"
  },
};

export const AOC_DELIVERIES = [
  "WBDShare",
  "CS-DMG Promos",
  "TWD MOST",
  "WMS Intl CS",
  "Vobile CTN Ep. Masters",
  "GCSSNY-MX_Content App",
]